import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'inc-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss'],
})
export class PageLoaderComponent implements OnInit {

  @Input() loading: boolean;

  constructor() { }

  ngOnInit() { }

}
